var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.type && _vm.symbol) || _vm.type == 'default')?_c('div',[(['default'].includes(_vm.type))?_c('div',[(_vm.name == 'main')?_c('Home_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginMain,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'mission')?_c('Activity_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginMission,
      }),attrs:{"color":_vm.color,"size":_vm.size}}):_vm._e(),(_vm.name == 'reward')?_c('Reward_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginReward,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'transport')?_c('Shipment_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginTransport,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'account')?_c('Account_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginAccount,
      }),attrs:{"color":_vm.color,"size":_vm.size}}):_vm._e(),(_vm.name == 'chat')?_c('Chat_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginChat,
      }),attrs:{"color":_vm.color,"noti":false}}):_vm._e(),(_vm.name == 'report')?_c('Clipboard_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginReport,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'campaign')?_c('Campaign_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginCampaign,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'request')?_c('Support_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginRequest,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'warranty')?_c('Warranty_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginWarranty,
      }),attrs:{"color":_vm.color}}):_vm._e(),(_vm.name == 'other')?_c('Other_Icon',{style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
        margin: _vm.marginOther,
      }),attrs:{"color":_vm.color}}):_vm._e()],1):_vm._e(),(['icon'].includes(_vm.type))?_c('div',[_c('div',{staticClass:"d-flex justify-center align-center",style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        border: _vm.outlined_box ? '1px solid #000000' : 'none',
      })},[_c('v-icon',{attrs:{"dark":"","color":_vm.color || '',"size":_vm.size}},[_vm._v(_vm._s(_vm.symbol))])],1)]):_vm._e(),(['image'].includes(_vm.type))?_c('div',[(_vm.symbol)?_c('div',{staticStyle:{"position":"relative"}},[(!_vm.is_display && !_vm.image_file)?_c('v-btn',{staticStyle:{"position":"absolute","top":"-24px","z-index":"1"},style:({
          left: _vm.size - 4 + 'px',
        }),attrs:{"dark":"","color":"primary","small":"","icon":""},on:{"click":_vm.handleClearSymbol}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-close ")])],1):_vm._e(),_c('v-img',{style:({
          'max-width': _vm.size + 'px',
          height: _vm.size + 'px',
          border: _vm.outlined_box ? '1px solid #000000' : 'none',
          'background-color': _vm.is_image_background_color
            ? '#fafafa'
            : 'transparent',
        }),attrs:{"src":_vm.symbol,"cover":""}})],1):_vm._e()]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }